import {useNavigate} from 'react-router-dom';
import history from 'core/history';

const CustomNavigate = () => {
  history.navigate = useNavigate();
  return null;
};

export default CustomNavigate;
